<ng-container *ngIf="this.simulationData.simulateds && this.simulationData.simulateds.length > 0; else noData">
  <div class="card-header">
    <div class="grid-x">
      <div class="cell auto">
        <h4 appEllipsisWithTooltip [id]="'WIDGET_'.concat(widget.size)">{{"widget.name.".concat(widget.widgetName) | translate}}</h4>
      </div>
    </div>
  </div>
  <div class="card-body">
    <div class="d-block padding-h-s">
      <div class="d-block margin-b-s">
      <span (click)="previousSimulation()"
            [ngStyle]="{'visibility': isFirstSimulation() ? 'hidden' : 'visible'}"
            class="cursor-hover fas fa-arrow-alt-circle-left padding-r-xs c-medium-gray"></span>
        <span class="c-dark-gray margin-b-xs i-block" style="font-weight:500;">
        {{currentSimulationLabel}}
      </span>
        <span (click)="nextSimulation()"
              [ngStyle]="{'visibility': isLastSimulation() ? 'hidden' : 'visible'}"
              class="cursor-hover fas fa-arrow-alt-circle-right padding-l-xs c-medium-gray"></span>
      </div>

      <div [chart]="chart" class="d-block" style="height: 78px;width: 98%"></div>
    </div>
  </div>
  <div class="card-footer">
    <a
      (click)="actionEvent.emit('widget.simulation.activate-simulation')"
      *ngIf="simulationData" [href]="redirectToInsito()"
      class="button insito">
    <span
      [title]="'widget.simulation.activate-simulation' | translate">
      {{'widget.simulation.activate-simulation' | translate}}</span>
    </a>
  </div>
</ng-container>
<ng-template #noData>
  <app-widget-message (actionEvent)="trackAction($event)"
                      [actionLabel]="'widget.simulation.activate-simulation' | translate"
                      [callToActionButtonLabel]="'widget.simulation.create-simulation' | translate"
                      [callToActionHref]="redirectToInsito()"
                      [message]="'widget.simulation.no-data'| translate"
                      [widgetLabel]="'widget.name.'.concat(widget.widgetName) | translate"
                      [widgetSize]="widget.size"
                      icone="opt-stat"></app-widget-message>
</ng-template>
